import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import type { ReactNode } from 'react';

interface Props {
  open: boolean;
  titel: string;
  children: ReactNode;
  bevestigLabel?: string | undefined;
  gevaarlijk?: boolean | undefined;
  bezig?: boolean | undefined;
  onBevestig: () => void;
  onSluit: () => void;
}

/**
 * Vraagt om bevestiging voor een actie die niet zomaar terug te draaien is, zoals verwijderen.
 * @param props De titel, de uitleg, het label van de knop en wat er bij bevestigen gebeurt.
 * @returns De dialoog.
 */
export function BevestigDialoog({
  open,
  titel,
  children,
  bevestigLabel = 'Bevestigen',
  gevaarlijk = false,
  bezig = false,
  onBevestig,
  onSluit,
}: Props) {
  return (
    <Dialog open={open} onClose={onSluit} maxWidth="xs" fullWidth>
      <DialogTitle>{titel}</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">{children}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onSluit} disabled={bezig}>
          Annuleren
        </Button>
        <Button
          onClick={onBevestig}
          variant="contained"
          color={gevaarlijk ? 'error' : 'primary'}
          loading={bezig}
          autoFocus
        >
          {bevestigLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
